//FulfillmentScreenIds + PostPlacementScreenIds merged into ScreenId
export enum ScreenId {
    none = "none",
    // Fulfillment
    fullFillmentTicketSystem = "full-fulfillment-ticket-system",
    loadVerification = "load-verification",
    loadVerificationAdmin = "verification-admin",
    loadFulfillment = "load-fulfillment",
    assuredLoads = "load-assured-list",

    // Post Placement
    ppTicketSystem = "post-placement-ticket-system",

    ppAllLoad = "pp-all-load",

    ppPlacement = "pp-placement",
    ppLoading = "pp-loading",
    ppUnloading = "pp-unloading",

    ppCompleted = "pp-completed",
    ppCancelled = "pp-cancelled",

    // Others

    executives = "executives",
    allUsers = "all-users",
    userRoles = "user-roles",
    userAttendance = "cs-attendance",
    agentStatus = "agent-status",
    admin = "admin",
    customer = "customer",
    trackScreen = "track-screen",
    ticketSystem = "ticket-system",
    tsm = "tsm",
    loadEnquiryCards = "load-enquiry-cards",
    lorryEnquiryCards = "lorry-enquiry-cards",
    customerProfile = "customer-profile",
    customerLorries = "customer-lorries",
    customerMarketplace = "customer-marketplace",
    myLoads = "myloads",
    myLorries = "mylorries",
    aadhaarVerification = "aadhaar-verification",
    panVerification = "pan-verification",
    ewayVerification = "eway-verification",
    businessVerification = "business-verification",
    rcVerification = "rc-verification",

    callMeBack = "call-me-back",
    membershipCallMeBack = "membership-call-me-back",
    loadPostSupport = "load-post-support",
    intransitCallMeBack = "intransit-call-me-back",
    refundRequest = "refund-request",
    cashbackStatus = "cashback-status",
    bidCancellation = "bid-cancellation",
    sendWhatsappMsg = "send-whatsapp-msg",
    blockUsers = "block-users",
    companyRegistrationLeads = "company-registration-leads",
    adsLeads = "ads-leads",
    companyDlVerification = "company-dl-verification",

    //TSO Common
    myReferrals = "my-referrals",
    newReferrals = "new-referrals",
    bulkTagging = "bulk-tagging",

    //TSO Load
    tsoLoadUser = "tsoLoadUser",
    tsoActiveLoadsPage = "tsoActiveLoadsPage",
    tsoInTransitLoadPage = "tsoInTransitLoadPage",
    tsoLoadEnquiryCard = "tsoLoadEnquiryCard",
    tsoLoadMarketPlace = "tso-load-marketplace",

    //TSO Lorry
    tsoLorryUser = "tsoLorryUser",
    tsoActiveLorryPage = "tsoActiveLorryPage",
    tsoInTransitLorryPage = "tsoInTransitLorryPage",
    tsoLorryEnquiryCard = "tsoLorryEnquiryCard",
    tsoLorryMarketPlace = "tso-lorry-marketplace",
    assuredAndSpotLoads = "assured-and-spot-loads",

    // Ticket System
    vasLeads = "vas-leads",
    help = "help",
    accountDeletion = "account-deletion",

    //Report groups
    reportSystem = "reportSystem",
    membershipReportSystem = "membershipReportSystem",
    cargoInsuranceReportSystem = "cargoInsuranceReportSystem",
    realTimeTransaction = "realTimeTransaction",
    tapNGoDepositRecord = "tapNGoDepositRecord",
    membershipPurchasedRecord = "membershipPurchasedRecord",
    membershipLead = "membershipLead",
    membershipLeadHistory = "membershipLeadHistory",
    cargoInsuranceLead = "cargoInsuranceLead",
    cargoInsuranceLeadHistory = "cargoInsuranceLeadHistory",

    // TSO New Screen
    tsoLeadSubmit = "tso-lead-submit",
    tsoLeadHistory = "tso-lead-history",
    tsoMyTaggedUser = "tso-my-tagged-users",
    // TSO new Screen For Admin
    tsoAdminScreens = "tso-admin",
    tsoAdminSessionsPage = "tso-admin-sessions",
    tsoAdminLeadsPage = "tso-admin-leads",
    tsoAdminLeadsDetailPage = "tso-admin-leads-details"
}

/** Display names for Post Placement ticket screens (nav / page titles). */
export const ScreenNameMap = {
    [ScreenId.ppAllLoad]: "PP All Loads",
    [ScreenId.ppPlacement]: "PP Placement",
    [ScreenId.ppLoading]: "PP Loading",
    [ScreenId.ppUnloading]: "PP Unloading",
    [ScreenId.ppCompleted]: "PP Completed",
    [ScreenId.ppCancelled]: "PP Cancelled"
} as const;
